if (!customElements.get('video-gallery')) {
  customElements.define(
    'video-gallery', 
    class VideoGallery extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.modalVideoIsPaused = false;

        this.videos = this.querySelectorAll('.video-gallery__media video');
        this.volumeButtons = this.querySelectorAll('.video-gallery__media .volume-button');
        
        this.sliderEl = this.querySelector('.video-gallery__slider');

        this.modal = this.querySelector('.video-gallery__modal');
        this.modalClose = this.querySelector('.video-gallery__modal-close');
        this.modalVideos = this.querySelectorAll('.video-gallery__modal-media video');
        
        this.modalPlayButton = this.querySelector('.video-gallery__modal-play');
        this.modalUnmuteButton = this.querySelector('.video-gallery__modal-unmute');
        this.modalVolumeButton = this.querySelector('.video-gallery__modal-volume-button');
        
        this.modalSliderEl = this.querySelector('.video-gallery__modal-slider');
        this.modalPrevButton = this.querySelector('.video-gallery__modal-prev');
        this.modalNextButton = this.querySelector('.video-gallery__modal-next');
        
        this.initSliders()
        
        this.sliderEl.addEventListener('click', () => {
          if (event.target.closest('.volume-button'))
            this.toggleVolume(this.videos, this.volumeButtons);
        });
        
        this.modalClose?.addEventListener('click', this.closeModal.bind(this));
        this.modalPlayButton?.addEventListener('click', this.toggleModalVideos.bind(this));
        
        this.modalUnmuteButton?.addEventListener('click', () => {
          this.modalUnmuteButton.classList.add('hidden');
          this.toggleVolume(this.modalVideos, [this.modalVolumeButton]);
        });

        this.modalVolumeButton?.addEventListener('click',  () => {
          this.modalUnmuteButton.classList.add('hidden');
          this.toggleVolume(this.modalVideos, [this.modalVolumeButton])
        });
      }

      initSliders() {
        this.slider = new Flickity( this.sliderEl, {
          wrapAround: true,
          contain: true,
          prevNextButtons: true,
          percentPosition: false,
          arrowShape: 'm75.12 98.54c1.33-1.34 1.33-3.52 0-4.87l-43.3-43.72 43.3-43.72c1.33-1.35 1.33-3.53 0-4.88-1.33-1.34-3.49-1.34-4.83 0l-44.55 44.99c-1.97 1.99-1.97 5.22 0 7.22l44.55 44.98c1.34 1.35 3.5 1.35 4.83 0z'
        });

        this.modalSlider = new Flickity( this.modalSliderEl, {
          wrapAround: true,
          contain: true,
          draggable: false,
          prevNextButtons: false,
          pageDots: false
        });

        this.slider.on('change', (index) => {
          this.toggleVideo(this.videos, index);
        });

        this.slider.on('staticClick', (event, pointer, cellElement, cellIndex) => {
          if (event.target.closest('video')) {
            this.openModal();
            this.playVideo(this.modalVideos, cellIndex);

            this.modalSlider.selectCell(cellIndex, false, true);
          }
        });

        this.modalSlider.on('change', (index) => {
          if (!this.modalVideoIsPaused)
            this.toggleVideo(this.modalVideos, index);
        });

        this.modalSlider.on('staticClick', (event, pointer, cellElement, cellIndex) => {
          this.toggleModalVideos();
        });

        this.modalPrevButton?.addEventListener('click', () => {
          this.modalSlider.previous();
        });

        this.modalNextButton?.addEventListener('click', () => {
          this.modalSlider.next();
        });
      }

      toggleVideo(videos, index) {
        videos.forEach((video, vindex) => {
          if (index == vindex) {
            video.play();
          } else {
            video.pause();
          }
        });
      }

      toggleModalVideos() {
        const index = this.modalSlider?.selectedIndex || 0;

        if (this.modalVideoIsPaused) {
          this.modalVideoIsPaused = false;
          this.modalPlayButton.classList.add('hidden');

          this.playVideo(this.modalVideos, index);
        } else {
          this.modalVideoIsPaused = true;
          this.modalPlayButton.classList.remove('hidden');

          this.pauseVideo(this.modalVideos, index);
        }
      }

      playVideo(videos, index) {
        videos.forEach((video, vindex) => {
          if (index == vindex) {
            video.play();
          }
        });
      }

      pauseVideo(videos, index) {
        videos.forEach((video, vindex) => {
          if (index == vindex) {
            video.pause();
          }
        });
      }

      toggleVolume(videos, volumeButtons) {
        videos.forEach(video => {
          video.muted = !video.muted;
        });
        
        volumeButtons.forEach(volumeButton => {
          volumeButton.classList.toggle('muted');
        });
      }

      openModal() {
        document.body.classList.add('overflow-hidden');
        this.modal.classList.add('opened');

        this.pauseVideo(this.videos, this.slider?.selectedIndex);
      }

      closeModal() {
        document.body.classList.remove('overflow-hidden');
        this.modal.classList.remove('opened');

        this.reset();
        this.playVideo(this.videos, this.slider?.selectedIndex);
      }

      reset() {
        this.modalVideoIsPaused = false;

        this.modalVideos.forEach((modalVideo) => {
          modalVideo.pause();
          modalVideo.muted = true;
        });
        
        this.modalPlayButton.classList.add('hidden');
        this.modalVolumeButton.classList.add('muted');
        this.modalUnmuteButton.classList.remove('hidden');
      }
    }
  )
}